import { RequiredCoding } from "./types";

export const diseases: RequiredCoding[] = [
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R14",
    display: "Acutely unwell children with a likely monogenic disorder",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R127",
    display: "Long QT syndrome",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R128",
    display: "Brugada syndrome and cardiac sodium channel disease",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R129",
    display: "Catecholaminergic polymorphic VT",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R130",
    display: "Short QT syndrome",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R131",
    display: "Hypertrophic cardiomyopathy",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R134",
    display: "Familial hypercholesterolaemia",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R184",
    display: "Cystic fibrosis diagnostic test",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R59",
    display: "Early onset or syndromic epilepsy",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R226",
    display: "Inherited parathyroid cancer",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R207",
    display: "Inherited ovarian cancer (without breast cancer)",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R211",
    display: "Inherited polyposis and early onset colorectal cancer - germline testing",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R215",
    display: "CDH1-related cancer syndrome",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R404",
    display: "Testing of unaffected individuals for inherited cancer predisposition syndromes",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R224",
    display: "Inherited renal cancer",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R364",
    display: "DICER1-related cancer predisposition",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R367",
    display: "Inherited pancreatic cancer",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R193",
    display: "Cystic renal disease",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R173",
    display: "Polycystic liver disease",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R65",
    display: "Aminoglycoside exposure posing risk to hearing",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R27",
    display: "Congenital malformation and dysmorphism syndromes - microarray and sequencing",
  },
  {
    system: "http://panelapp.genomicsengland.co.uk/api/v1/entities",
    code: "R29",
    display: "Intellectual disability - microarray and sequencing",
  },
];
